import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { MBSApplicationHeader, MBSApplicationHeaderProps, MBSModule } from '@fides/fides-react-components';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';
import { ENV } from 'core/consts';
import { useLocation } from 'react-router-dom';

type MainContentProps = {
  $variant: 'normal' | 'medium' | 'full';
};

export const MainContent = styled.div<MainContentProps>`
  ${({ $variant }) => {
    if ($variant === 'full')
      return `
        display: flex;
        flex: 1;
      `;
    return null;
  }}

  padding: ${({ $variant }) => {
    if ($variant === 'medium') return '0px 64px';
    if ($variant === 'normal') return '0px 64px 0 64px';
    return 0;
  }};
`;

type ApplicationHeaderPageProps = {
  pageTitle?: string;
  isMaster?: boolean;
  isUserMenu?: boolean;
  variant?: MainContentProps['$variant'];
  displayCompanyLogo?: boolean;
};

export const ApplicationHeaderPage: FC<PropsWithChildren<ApplicationHeaderPageProps>> = ({
  children,
  pageTitle,
  isMaster = false,
  isUserMenu = false,
  variant = 'normal',
  displayCompanyLogo,
}) => {
  const { user } = useGlobalConfigContext();
  const location = useLocation();
  const applicationHeaderProps: MBSApplicationHeaderProps['applicationHeaderProps'] = {
    isMaster,
    isUserMenu,
    isDLCMenu: location.pathname.indexOf(MBSModule.DLC) !== -1 || false,
    displayCompanyLogo,
  };
  const mbsApplicationHeaderProps: MBSApplicationHeaderProps['mbsApplicationHeaderProps'] = {
    applications: user?.applications,
    portalUser: {
      ...user,
    },
    pageTitle,
    crumbs: [],
    portalDirectory: ENV.PORTAL_DIRECTORY,
    language: user?.settings?.personal?.language,
  };

  return (
    <>
      <MBSApplicationHeader
        applicationHeaderProps={applicationHeaderProps}
        mbsApplicationHeaderProps={mbsApplicationHeaderProps}
      />
      <MainContent $variant={variant}>{children}</MainContent>
    </>
  );
};
